import { useLanguage } from '../context/LanguageContext';
import { normalizeDay } from '../components/Data/familyCompat';

export const translations = {
  en: {
    auth: {
      signInTitle: "Sign In",
      signInSubtitle: "Enter your phone number to continue",
      phoneLabel: "Phone Number",
      phonePlaceholder: "(123) 456-7890",
      continueButton: "Continue",
      selectMethodTitle: "Choose Verification Method",
      selectMethodSubtitle: "How would you like to receive your verification code?",
      textMethod: "Text",
      callMethod: "Call",
      selectMethodDemo: "Both options will work in demo mode",
      verificationTitle: "Verification Code",
      verificationSubtitle: "Enter the 6-digit code sent to your phone",
      codeLabel: "Enter Code",
      codePlaceholder: "Enter 6-digit code",
      verifyButton: "Verify",
      verifying: "Verifying...",
      sendingCode: "Sending...",
      backButton: "Back",
      invalidPhone: "Please enter a valid phone number",
      invalidCode: "Please enter a valid 6-digit code",
      enterFullCode: "Please enter the full 6-digit code.",
      invalidCodeTryAgain: "Invalid verification code. Please try again.",
      waitBeforeResend: "Please wait before requesting another code.",
      waitSeconds: "Please wait {seconds}s before requesting another code.",
      phoneNotFound: "Phone number not found. Please check your number or contact Ruslan Matev if you believe this is correct.",
      sendFailed: "Unable to send a verification code. Please try again.",
      verifyFailed: "Verification failed. Please request a new code.",
      familyLoadFailed: "Family data could not be loaded.",
      accountLoadFailed: "Signed in, but account data could not be loaded.",
      noAccountData: "Signed in, but no family or class data was found for this account.",
      viaSms: "via text message",
      viaCall: "via phone call",
      viaCode: "via verification code",
      digitOfCode: "Digit {n} of verification code",
      sendingVerificationCode: "Sending verification code...",
      chooseMethodHint: "Choose how you'd like to receive your verification code"
    },
    common: {
      logoAlt: "Ark of Salvation logo",
      family: "Family",
      close: "Close",
      loading: "Loading...",
      settings: "Settings",
      openSettings: "Open settings",
      closeSettings: "Close settings",
      groupDataHint: "Select how to group the data.",
      saveViewHint: "Save the current view for sharing or printing."
    },
    main: {
      studentView: "Student View",
      activityView: "Activity View", 
      dateView: "Date View",
      viewSettings: "View Settings",
      exportOptions: "Save & Print",
      export: "Export",
      share: "Share",
      saveCopy: "Save a copy",
      saveCopyHint: "To print or send later",
      printHint: "Send to a printer",
      print: "Print",
      signOut: "Sign Out",
      noFamilyData: "Could not retrieve family data.",
      loadingFamily: "Loading family...",
      lastUpdated: "Last Updated",
      activity: "activity",
      activities: "activities",
      student: "student", 
      students: "students",
      today: "Today",
      noClasses: "No classes",
      noClassesThisWeek: "No classes scheduled this week"
    },
    activities: {
      sundaySchool: "Sunday School",
      russianSchool: "Russian School",
      childrensChoir: "Children's Choir"
    },
    details: {
      class: "Class",
      teachers: "Teachers",
      room: "Room",
      classroom: "Classroom",
      choirNumber: "Choir #",
      choirLeaders: "Leaders",
      choirRoom: "Choir Room",
      birthday: "Birthday",
      moreTeachers: "{n} more",
      fewerTeachers: "Show fewer",
      studentsGroupedView: "Students grouped view",
      activitiesGroupedView: "Activities grouped view",
      // Plural forms: {n} is the number; suffix One/Few/Many is picked by plural()
      ageOne: "Age {n}",
      ageFew: "Age {n}",
      ageMany: "Age {n}",
      activitiesOne: "{n} activity",
      activitiesFew: "{n} activities",
      activitiesMany: "{n} activities"
    },
    report: {
      familyInformation: "Family Information",
      student: "Student",
      activity: "Activity",
      details: "Details",
      teachersLeaders: "Teachers/Leaders",
      day: "Day",
      noData: "No data available.",
      defaultFamily: "Family",
      fileNameSuffix: "Church-Activities",
      shareTitle: "Activity Report",
      shareText: "Family activity report"
    },
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    },
    daysShort: {
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun"
    },
    modules: {
      admin: "Admin",
      adminSubtitle: "All Classes & Students",
      navigation: "Navigation",
      collapse: "Collapse",
      collapseNav: "Collapse navigation",
      expandNav: "Expand navigation",
      signOut: "Sign out",
      types: {
        sundaySchool: "Sunday School",
        russianSchool: "Russian School",
        childrensChoir: "Choir"
      },
      classPrefix: "Class",
      choirPrefix: "Choir",
      day: "Day",
      room: "Room",
      location: "Location",
      teachers: "Teachers",
      leaders: "Leaders",
      student: "Student",
      students: "Students",
      birthday: "Birthday",
      age: "Age",
      name: "Name",
      classes: "Classes",
      parents: "Parents",
      children: "Children",
      families: "Families",
      all: "All",
      back: "Back",
      sortBy: "Sort by",
      searchStudents: "Search students",
      searchAdmin: "Search classes, families, students",
      noStudents: "No students found",
      noStudentsMatch: "No students match “{q}”",
      noMatches: "No matches",
      notEnrolled: "Not enrolled in any classes",
      moreResults: "{n} more — keep typing to narrow",
      showParentContacts: "Show parent contacts ({n})",
      boy: "boy",
      girl: "girl",
      // Plural forms: {n} is the number; suffix One/Few/Many is picked by plural form
      studentsCountOne: "{n} student",
      studentsCountFew: "{n} students",
      studentsCountMany: "{n} students"
    },
    signOut: {
      title: "Sign out?",
      body: "You'll need your phone number and a new code to sign back in.",
      cancel: "Stay signed in",
      confirm: "Sign out"
    }
  },
  ru: {
    auth: {
      signInTitle: "Вход",
      signInSubtitle: "Введите ваш номер телефона, чтобы продолжить",
      phoneLabel: "Номер телефона",
      phonePlaceholder: "(123) 456-7890",
      continueButton: "Продолжить",
      selectMethodTitle: "Выберите способ подтверждения",
      selectMethodSubtitle: "Как вы хотите получить код подтверждения?",
      textMethod: "SMS",
      callMethod: "Звонок",
      selectMethodDemo: "Оба варианта работают в демо-режиме",
      verificationTitle: "Код Подтверждения",
      verificationSubtitle: "Введите 6-значный код, отправленный на ваш телефон",
      codeLabel: "Введите Код",
      codePlaceholder: "Введите 6-значный код",
      verifyButton: "Подтвердить",
      verifying: "Проверка...",
      sendingCode: "Отправка...",
      backButton: "Назад",
      invalidPhone: "Пожалуйста, введите действительный номер телефона",
      invalidCode: "Пожалуйста, введите действительный 6-значный код",
      enterFullCode: "Пожалуйста, введите полный 6-значный код.",
      invalidCodeTryAgain: "Неверный код подтверждения. Попробуйте еще раз.",
      waitBeforeResend: "Пожалуйста, подождите перед повторным запросом кода.",
      waitSeconds: "Пожалуйста, подождите {seconds} с перед повторным запросом кода.",
      phoneNotFound: "Номер телефона не найден. Проверьте номер или свяжитесь с Русланом Матевым, если считаете, что он верный.",
      sendFailed: "Не удалось отправить код подтверждения. Попробуйте еще раз.",
      verifyFailed: "Не удалось выполнить проверку. Запросите новый код.",
      familyLoadFailed: "Не удалось загрузить данные семьи.",
      accountLoadFailed: "Вход выполнен, но не удалось загрузить данные аккаунта.",
      noAccountData: "Вход выполнен, но для этого аккаунта не найдены данные семьи или класса.",
      viaSms: "по SMS",
      viaCall: "по телефону",
      viaCode: "код подтверждения",
      digitOfCode: "Цифра {n} кода подтверждения",
      sendingVerificationCode: "Отправка кода подтверждения...",
      chooseMethodHint: "Выберите, как вы хотите получить код подтверждения"
    },
    common: {
      logoAlt: "Логотип «Ковчег Спасения»",
      family: "Семья",
      close: "Закрыть",
      loading: "Загрузка...",
      settings: "Настройки",
      openSettings: "Открыть настройки",
      closeSettings: "Закрыть настройки",
      groupDataHint: "Выберите, как сгруппировать данные.",
      saveViewHint: "Сохраните текущий вид, чтобы поделиться или распечатать."
    },
    main: {
      studentView: "По ученикам",
      activityView: "По занятиям",
      dateView: "По дням",
      viewSettings: "Настройки просмотра",
      exportOptions: "Сохранить и распечатать",
      export: "Экспорт",
      share: "Поделиться",
      saveCopy: "Сохранить копию",
      saveCopyHint: "Чтобы распечатать или отправить позже",
      printHint: "Отправить на принтер",
      print: "Печать",
      signOut: "Выйти",
      noFamilyData: "Не удалось получить данные семьи.",
      loadingFamily: "Загрузка семьи...",
      lastUpdated: "Последнее обновление",
      activity: "занятие",
      activities: "занятий",
      student: "ученик",
      students: "учеников",
      today: "Сегодня",
      noClasses: "Нет занятий",
      noClassesThisWeek: "На этой неделе занятий нет"
    },
    activities: {
      sundaySchool: "Воскресная школа",
      russianSchool: "Русская школа", 
      childrensChoir: "Детский хор"
    },
    details: {
      class: "Класс",
      teachers: "Учителя",
      room: "Комната",
      classroom: "Класс",
      choirNumber: "Хор №",
      choirLeaders: "Руководители",
      choirRoom: "Комната хора",
      birthday: "День рождения",
      moreTeachers: "Ещё {n}",
      fewerTeachers: "Свернуть",
      studentsGroupedView: "Просмотр по ученикам",
      activitiesGroupedView: "Просмотр по занятиям",
      // 1 год / 2–4 года / 5–20 лет / 21 год / 22 года …
      ageOne: "{n} год",
      ageFew: "{n} года",
      ageMany: "{n} лет",
      activitiesOne: "{n} занятие",
      activitiesFew: "{n} занятия",
      activitiesMany: "{n} занятий"
    },
    report: {
      familyInformation: "Семейная информация",
      student: "Ученик",
      activity: "Занятие",
      details: "Детали",
      teachersLeaders: "Учителя/Руководители",
      day: "День",
      noData: "Нет данных.",
      defaultFamily: "Семья",
      fileNameSuffix: "Церковные-занятия",
      shareTitle: "Отчёт о занятиях",
      shareText: "Отчёт о занятиях семьи"
    },
    days: {
      monday: "Понедельник",
      tuesday: "Вторник",
      wednesday: "Среда",
      thursday: "Четверг",
      friday: "Пятница",
      saturday: "Суббота",
      sunday: "Воскресенье"
    },
    daysShort: {
      monday: "Пн",
      tuesday: "Вт",
      wednesday: "Ср",
      thursday: "Чт",
      friday: "Пт",
      saturday: "Сб",
      sunday: "Вс"
    },
    modules: {
      admin: "Администратор",
      adminSubtitle: "Все классы и ученики",
      navigation: "Навигация",
      collapse: "Свернуть",
      collapseNav: "Свернуть навигацию",
      expandNav: "Развернуть навигацию",
      signOut: "Выйти",
      types: {
        sundaySchool: "Воскресная школа",
        russianSchool: "Русская школа",
        childrensChoir: "Детский хор"
      },
      classPrefix: "Класс",
      choirPrefix: "Хор",
      day: "День",
      room: "Комната",
      location: "Место",
      teachers: "Учителя",
      leaders: "Руководители",
      student: "Ученик",
      students: "Ученики",
      birthday: "День рождения",
      age: "Возраст",
      name: "Имя",
      classes: "Классы",
      parents: "Родители",
      children: "Дети",
      families: "Семьи",
      all: "Все",
      back: "Назад",
      sortBy: "Сортировка",
      searchStudents: "Поиск учеников",
      searchAdmin: "Поиск по классам, семьям, ученикам",
      noStudents: "Ученики не найдены",
      noStudentsMatch: "Нет учеников по запросу «{q}»",
      noMatches: "Ничего не найдено",
      notEnrolled: "Не записан ни в один класс",
      moreResults: "Ещё {n} — уточните запрос",
      showParentContacts: "Показать контакты родителей ({n})",
      boy: "мальчик",
      girl: "девочка",
      studentsCountOne: "{n} ученик",
      studentsCountFew: "{n} ученика",
      studentsCountMany: "{n} учеников"
    },
    signOut: {
      title: "Выйти из аккаунта?",
      body: "Чтобы войти снова, понадобится номер телефона и новый код.",
      cancel: "Остаться",
      confirm: "Выйти"
    }
  }
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  /** t('ns.key') -> string; t('ns.key', { n: 3 }) fills `{n}` placeholders. */
  const t = (key, params) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation missing for key: ${key} in language: ${language}`);
        return key; // Return the key if translation is missing
      }
    }

    if (params && typeof value === 'string') {
      return value.replace(/\{(\w+)\}/g, (match, name) =>
        name in params ? String(params[name]) : match
      );
    }
    return value;
  };

  /** For messages that may be either a translation key ("auth.sendFailed") or
   *  literal text (e.g. an error string from the server): translate the former,
   *  pass the latter through unchanged. */
  const tMessage = (value) =>
    typeof value === 'string' && isTranslationKey(value) ? t(value) : value;

  /** tn('details.age', 5) -> "Age 5" | "5 лет": the plural form for n. */
  const tn = (key, n) => plural(key, n, language);

  return { t, tMessage, tn, language };
};

/** BCP-47 locale for Intl / toLocaleDateString that follows the app language. */
export const localeFor = (language = 'en') => (language === 'ru' ? 'ru-RU' : 'en-US');

/** Plural category suffix for a count: Russian has three forms
 *  (1 год / 2–4 года / 5–20 лет, repeating by the last digit, with 11–14
 *  always "many"); English has one/many. Returned as the key suffix used in
 *  the tables: "One" | "Few" | "Many". */
export const pluralCategory = (n, language = 'en') => {
  const abs = Math.abs(Math.trunc(Number(n) || 0));
  if (language === 'ru') {
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (mod10 === 1 && mod100 !== 11) return 'One';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'Few';
    return 'Many';
  }
  return abs === 1 ? 'One' : 'Many';
};

/** Hook-free plural lookup: plural('details.activities', 3, 'ru') reads
 *  translations.ru.details.activitiesFew and fills its `{n}`. Falls back to the
 *  English form, then to the bare number, so a missing key never crashes. */
export const plural = (key, n, language = 'en') => {
  const [ns, base] = key.split('.');
  const pick = (lang) => translations[lang]?.[ns]?.[`${base}${pluralCategory(n, lang)}`];
  const form = pick(language) ?? pick('en');
  if (typeof form !== 'string') {
    console.warn(`Translation missing for plural key: ${key} in language: ${language}`);
    return String(n);
  }
  return form.replace(/\{n\}/g, String(n));
};

/** "auth.sendFailed" -> true; "Something went wrong." -> false. */
export const isTranslationKey = (value) =>
  typeof value === 'string' && /^[a-zA-Z]+\.[a-zA-Z]+$/.test(value);

/** Day string from any payload ("СРЕДА", "Wednesday", "ср" …) rendered in the
 *  given language, for places that have no hook context (PDF, plain helpers).
 *  Falls back to the raw value when the day is unrecognized. */
export const dayLabel = (day, language = 'en') => {
  const canonical = normalizeDay(day);
  if (!canonical) return day ?? '';
  const table = translations[language]?.days || translations.en.days;
  return table[canonical.toLowerCase()] || canonical;
};
